import { useState } from 'react';

const faqs = [
  {
    q: '7777影院是否需要注册或付费？',
    a: '完全不需要。7777影院所有电影、电视剧、综艺和动漫资源均免费在线观看，无需注册账号，无需付费订阅，打开网站即可畅享高清影视内容。我们坚持免费服务，让每一位影迷都能无门槛享受观影乐趣。',
  },
  {
    q: '播放视频时会不会卡顿或缓冲？',
    a: '不会。7777影院部署了全网CDN加速节点，采用先进的视频分发技术，确保在全国各地都能获得流畅的播放体验。同时我们提供多线路切换功能，当某条线路繁忙时可自动切换至最优节点，告别缓冲烦恼。',
  },
  {
    q: '支持哪些画质？有没有4K资源？',
    a: '7777影院提供从流畅（480P）到超清4K的多档画质选择。热门电影和最新剧集均提供4K杜比视界版本，部分院线大片还支持HDR显示。您可以根据网络状况和设备性能自由切换画质，获得最佳观看体验。',
  },
  {
    q: '资源更新速度如何？每天更新多少内容？',
    a: '我们的编辑团队7×24小时不间断更新，每日新增影视资源超过200部。电视剧与播出平台同步更新，热门综艺上线后2小时内即可观看，院线电影下映后第一时间上线高清版本，确保你永远走在追剧最前线。',
  },
  {
    q: '手机和平板可以观看吗？有没有APP？',
    a: '当然可以。7777影院采用响应式网页设计，完美适配手机、平板、电脑等各类设备，无需下载任何APP。在手机浏览器中打开网站即可获得与APP一样的流畅体验。同时我们也提供PWA安装方式，可添加到手机桌面一键直达。',
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFaq = (i: number) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[900px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 font-heading mb-3">
            常见问题
          </h2>
          <p className="text-foreground-600 max-w-lg mx-auto">
            关于7777影院，你想知道的都在这里
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="border border-background-200 rounded-xl overflow-hidden"
            >
              <button
                onClick={() => toggleFaq(i)}
                className="w-full flex items-center justify-between p-5 text-left hover:bg-background-50 transition-colors cursor-pointer"
              >
                <h3 className="text-base font-semibold text-foreground-800 pr-4">
                  {faq.q}
                </h3>
                <div
                  className={`w-6 h-6 flex items-center justify-center rounded-full transition-colors flex-shrink-0 ${
                    openIndex === i
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-200 text-foreground-500'
                  }`}
                >
                  <i
                    className={`ri-${
                      openIndex === i ? 'subtract' : 'add'
                    }-line text-sm`}
                  ></i>
                </div>
              </button>
              <div
                className={`transition-all duration-300 ease-in-out overflow-hidden ${
                  openIndex === i ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-5 pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {faq.a}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}